import React, { useState } from "react";
import { toast } from "react-hot-toast";

const AddAccessoryModal = ({ isOpen, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch("https://wittynailtip.com/backend/admin-upload-accessory.php", {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const result = await response.json();
      if (result.success) {
        toast.success(result.message || "Accessory added successfully!");
        onSuccess();
        onClose();
      } else {
        toast.error(result.message || "Failed to add accessory.");
        if (result.debug) console.log("PHP Debug Info:", result.debug);
      }
    } catch (error) {
      toast.error("An error occurred during upload.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm font-jost">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        
        {/* Header */}
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-white border-b border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900">Add New Accessory</h2>
          <button onClick={onClose} className="p-2 text-gray-400 transition-colors hover:text-gray-600">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-700">Title *</label>
              <input type="text" name="title" required placeholder="Enter accessory title" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#FFB7CF] focus:border-transparent outline-none transition-all" />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-700">Description *</label>
              <textarea name="description" required rows="4" placeholder="Enter accessory description" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#FFB7CF] focus:border-transparent outline-none transition-all"></textarea>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">Price (USD) *</label>
                <input type="number" name="price" step="0.01" min="0" required placeholder="0.00" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#FFB7CF] focus:border-transparent outline-none transition-all" />
              </div>
              
              <div className="space-y-2">
                <label className="block text-sm font-semibold text-gray-700">Total Quantity *</label>
                <input type="number" name="quantity" min="0" required placeholder="0" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#FFB7CF] focus:border-transparent outline-none transition-all" />
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-700">Main Image *</label>
              <input type="file" name="image" accept="image/*" required className="w-full px-4 py-2 border border-gray-200 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#fff1f5] file:text-[#FFB7CF] hover:file:bg-[#ffe1ea] rounded-xl outline-none" />
              <p className="text-xs text-gray-500">This image will be used as the primary display and uploaded to Stripe.</p>
            </div>
          </div>

          {/* Additional Images */}
          <div className="pt-6 border-t border-gray-100">
            <h3 className="mb-4 text-sm font-bold text-gray-900 uppercase tracking-wide">Additional Images (Optional)</h3>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {[2, 3, 4, 5].map((num) => (
                <div key={num} className="space-y-1">
                  <label className="block text-xs font-medium text-gray-500">Extra Image {num}</label>
                  <input type="file" name={`pimg${num}`} accept="image/*" className="w-full text-sm text-gray-500 file:mr-2 file:py-1 file:px-3 file:rounded-full file:border-0 file:text-xs file:font-medium file:bg-gray-100 file:text-gray-700" />
                </div>
              ))}
            </div>
          </div>

          {/* Footer Actions */}
          <div className="flex items-center justify-end gap-3 pt-6 border-t border-gray-100">
            <button type="button" onClick={onClose} className="px-6 py-2.5 font-semibold text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
              Cancel
            </button>
            <button type="submit" disabled={loading} className="px-8 py-2.5 font-semibold text-white bg-[#FFB7CF] rounded-full hover:bg-[#ff9cbb] transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2">
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
                  Uploading...
                </>
              ) : (
                "Save Accessory"
              )}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default AddAccessoryModal;
